 import { reactive, ref } from 'vue'
 import { toast, variant } from '@/core/helper/utility'
 import { httpStatusCode } from '@/core/helper/httpStatusCode';
 import { GetAll } from "@/infrastructure/repositories/botTypeRepository"
 
 export const useBotType = () => {
     var filter = reactive({});
     var botTypes = ref([]);
     var isLoading = ref(false);

     const getBotTypes = async () => {
         try {
             isLoading.value = true;
 
             var response = await GetAll(filter);

             if(response.status == httpStatusCode.OK){
                botTypes.value = response.data.value;
             }else{
                 toast({
                     collection: true,
                     variant: variant.error,
                     title: response.data.title,
                     body:  response.data.messages
                 });
             }

             isLoading.value = false;
         } catch (error) {
             isLoading.value = false;
             toast({
                 variant: variant.error,
                 title: 'Bot Types',
                 body: 'Could not get bot types list, check again, please contact support center'
             });
     
             throw new Error(error);
         }
     }

     return {
         isLoading,
         botTypes,
         getBotTypes
     }
 }